import { tipoInputEnum, tipoInputPadraoEnum } from "../components/CampoForm/enum/TipoInput.enum";
import { gerarGUID, gerarUUID } from "../util/uuid.utils";
import { tipoFormularioEnum } from "../enums/tipoFormularioEnum";

/**
 * Modelo de objeto para Formulário Personalizado;
 * @class Formulario
 * @namespace Formulario
 */
export default class Formulario {
  constructor(id = null, nome = '', nomeHtml = '', camposEmpresa = [], camposSocio = [], tipoFormulario = tipoFormularioEnum.PROCESSO_ELEGALIZE.getId()) {
    this.id = id;
    this.nome = nome;
    this.nomeHtml = nomeHtml;
    this.camposEmpresa = camposEmpresa;
    this.camposSocio = camposSocio;
    this.tipoFormulario = tipoFormulario;
  }

  /**
   * Atualiza modelo com dados válidos de um objeto com dados de
   * formulário;
   * @param {Object} formData Objeto com dados do formulário
   */
  updateDados(formData) {
    for (let propriedade in formData) {
      if (!Object.keys(formData).includes(propriedade)) {
        console.warn(`WARN: Propriedade "${propriedade}" não é valido para modelo`);
        continue;
      }
      this[propriedade] = formData[propriedade];
    }
  }

  asRequestBody() {
    let camposClone = JSON.stringify([
      ...this.camposEmpresa.map((item, index) => {
        item.ordem = index+1;
        return item;
      }),
      ...this.camposSocio.map((item, index) => {
        item.ordem = index+1;
        return item;
      }),
    ]);
    camposClone = JSON.parse(camposClone);
    const body = {
      nome: this.nome,
      nomeHtml: this.nomeHtml,
      camposPersonalizados: this.converterCamposToRequest(camposClone),
      tipoFormulario: this.tipoFormulario
    }
    if (this.id) {
      body.id = this.id;
    }
    return body;
  }

  converterCamposToRequest(campos) {
    const camposTratados = [];
    for(const campo of campos) {
      delete campo.respostaOpcoes;
      delete campo.respostaTexto;
      if(Array.isArray(campo.opcoes) && campo.opcoes.length > 0) {
        campo.opcoes = this.converterOpcoesToRequest(campo.opcoes);
      }
      if(!campo.blocoPadrao) {
        campo.tipoInput = tipoInputEnum.getByKey(campo.tipoInput).getId();
        camposTratados.push(campo);
        continue;
      }
      delete campo.tipoInput;
      camposTratados.push(campo);
    }
    return camposTratados;
  }

  converterOpcoesToRequest(opcoes) {
    const opcoesConvertidas = [];
    for(const opcao of opcoes) {
      const opcaoConvertida = {
        ordem: opcao.ordem,
        descricao: opcao.label,
        descricaoHtml: opcao.labelHtml
      }
      opcoesConvertidas.push(opcaoConvertida)
    }
    opcoesConvertidas.sort((a, b) => a.ordem - b.ordem);
    return opcoesConvertidas
  }

  cleanBody(body) {
    for (const prop in body) {
      if (body[prop] === '' || body[prop] === null || (Array.isArray(body[prop]) && body[prop].length == 0)) {
        delete body[prop];
      }
    }
  }

  asModel(response) {
    this.id = response.id;
    this.nome = response.nome;
    this.nomeHtml = response.nomeHtml;
    this.tipoFormulario = response.tipoFormulario;
    
    const {camposEmpresa, camposSocio} = this.converterCamposToModel(response.camposPersonalizados);

    this.camposEmpresa = camposEmpresa;
    this.camposSocio = camposSocio;
  }

  converterCamposToModel(campos) {
    const camposEmpresa = [];
    const camposSocio = [];
    campos.sort((a, b) => a.ordem - b.ordem);
    for(const campo of campos) {
      if(Array.isArray(campo.opcoes) && campo.opcoes.length > 0) {
        campo.opcoes = this.converterOpcoesToModel(campo.opcoes);
      }
      if(!!campo.blocoPadrao) {
        campo.tipoInput = tipoInputPadraoEnum.getById(campo.blocoPadrao).getKey();
      } else {
        campo.tipoInput = tipoInputEnum.getById(campo.tipoInput).getKey();
      }

      campo.uuid = gerarUUID();

      if(campo.isCampoSocio) {
        camposSocio.push(campo)
      } else {
        camposEmpresa.push(campo)
      }
    }
    return {camposEmpresa, camposSocio};
  }

  converterOpcoesToModel(opcoes) {
    const opcoesConvertidas = [];
    for(const opcao of opcoes) {
      const opcaoConvertida = {
        ordem: opcao.ordem,
        label: opcao.descricao,
        labelHtml: opcao.descricaoHtml,
        uuidEditor: gerarGUID()
      }
      opcoesConvertidas.push(opcaoConvertida)
    }
    opcoesConvertidas.sort((a, b) => a.ordem - b.ordem);
    return opcoesConvertidas
  }
}
